import React, { useState } from 'react';
import { Icon } from '@iconify/react';
import styled from 'styled-components';
import { Button } from '@mui/material';
import { Link } from 'react-scroll';
import DesignedByContainer from './DesignedByContainer';
import PhoneEnabledIcon from '@mui/icons-material/PhoneEnabled';
import EmailIcon from '@mui/icons-material/Email';

const Footer = () => {
  const [anchorElNav, setAnchorElNav] = useState(null);

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  return (
    <>
      <FooterContainer>
        <FooterContent>
          <div className='logo-socials'>
            <Button
              onClick={handleCloseNavMenu}
              disableRipple={true}
              style={{ backgroundColor: 'transparent' }}
            >
              <Link spy={true} smooth={true} duration={500} to='nav'>
                <LogoBrandContainer>
                  <LogoImage
                    className='nav'
                    src='/leafIcon.png'
                    alt='leafIcon logo'
                    width={270}
                    height={200}
                  ></LogoImage>
                  <BrandTitle>Speak Easy with Brandy</BrandTitle>
                </LogoBrandContainer>
              </Link>
            </Button>
          </div>

          <QuickLinksContainer>
            <h3>Quick Links</h3>

            <Link
              className='link'
              spy={true}
              smooth={true}
              duration={500}
              to='aboutMe'
            >
              <p>About Me</p>
            </Link>

            <Link
              className='link'
              spy={true}
              smooth={true}
              duration={500}
              to='services'
            >
              <p>Services</p>
            </Link>

            <Link
              className='link'
              spy={true}
              smooth={true}
              duration={500}
              to='contactUs'
            >
              <p>Contact</p>
            </Link>
          </QuickLinksContainer>

          <ContactInfoContainer>
            <h3>Contact Me</h3>


            <div className='info'>
              <PhoneEnabledIcon height={8} width={8} />
              <p>(929)-548-3290</p>
            </div>

            <div className='info'>
              <EmailIcon height={8} width={8} />
              <a
                href='mailto:speechwithbrandy@gmail.com'
                style={{ textDecoration: 'none', color: 'black' }}
              >
                speechwithbrandy@gmail.com
              </a>
            </div>
          </ContactInfoContainer>
        </FooterContent>
      </FooterContainer>
      <DesignedByContainer />
    </>
  );
};

export default Footer;

const LogoBrandContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin: auto;
  gap: 10px;
  align-items: center;
  margin-top: 110px;
  margin-left: 10px;

  @media (max-width: 768px) {
    display: none;
  }
`;

const BrandTitle = styled.div`
  font-size: 25px;
  font-weight: 500;
  text-transform: none;
  color: black;
  font-family: 'Georgia', serif;
  letter-spacing: 0.5px;
`;

const FooterContainer = styled.footer`
  color: black;
  display: flex;
  flex-direction: column;
  bottom: 0px;
  text-align: center;
  margin: 0;
  padding: 10px;
  bottom: 0px;
  align-items: center;
`;

const FooterContent = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin: auto;

  .logo-socials {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
  }

  @media (min-width: 375px) and (max-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

const LogoImage = styled.img`
  height: 50px;
  width: 50px;

  @media (min-width: 375px) and (max-width: 768px) {
    display: none;
  }
`;

const QuickLinksContainer = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 1pt;
  color: #2c3e50;
  margin-top: 28px;
  margin-left: auto;
  margin-right: 2rem;

  .link:hover {
    cursor: pointer;
    color: #008080;
  }

  @media (min-width: 375px) and (max-width: 768px) {
    display: none;
  }
`;

const ContactInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  text-align: start;
  padding: 1rem;

  h3 {
    margin-bottom: 0;
  }

  @media (min-width: 375px) and (max-width: 768px) {
    display: flex;
    align-items: start;
  }

  .info,
  .address-container {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 14px;
    color: black;
    line-height: 2pt;
    margin-top: 0.5rem;
  }
`;
